// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';

import bus from './public/bus.js'

Vue.config.silent = true;

Vue.use(ElementUI, { size: 'small' });
Vue.prototype.$axios = axios;
axios.defaults.baseURL = 'http://api.sywlfz.com/';
//axios.defaults.baseURL = 'http://192.168.83.51:18102/';
// Vue.prototype.$imgUrl = 'http://file.sywlfz.com';

Vue.config.productionTip = false

router.beforeEach((to,from,next)=>{
   Vue.prototype.$swiper = to.path;
   bus.$emit('pageChange',to.path);
    next();
})
Vue.filter('formatTime',(value)=>{
  let time = new Date(value)
  return time.getFullYear() + '/' + (time.getMonth() + 1) + '/' + time.getDate();
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js